import React from "react";
import { useTranslation } from "react-i18next";

const BudgetDisplay = ({ budgetData }: any) => {
  const { t } = useTranslation("myArea");

  if (!budgetData) {
    return null;
  }

  return (
    <div className="rounded-lg">
      {/* Budget Summary */}
      <div className="mb-8">
        <div className=" gap-12 md:flex ">
          <div className="flex items-center">
            <div className="text-Grey-dark ">
              {t("credits.overall-budget")}:
            </div>
            <div className=" ml-4 font-semibold">
              {parseFloat(budgetData.budget).toFixed(2)} €
            </div>
          </div>

          <div className="flex items-center">
            <div className="text-Grey-dark ">
              {t("credits.available-budget")}:
            </div>
            <div className=" ml-4  font-semibold">
              {parseFloat(budgetData.remainingBudget).toFixed(2)} €
            </div>
          </div>
        </div>
      </div>

      {/* Budget Table */}
      <div className=" bg-Grey-light-3 rounded-md p-4">
        <div className="overflow-x-auto">
          <table className="table-auto w-full hidden md:table">
            <thead className="w-full border-b">
              <tr>
                <th className="text-left pb-2">
                  {t("credits.budget-table-title")}
                </th>
                <th className="text-left pb-2 ">
                  {t("credits.budget-table-date")}
                </th>
                <th className="text-right pb-2 ">
                  {t("credits.budget-table-value")}
                </th>
              </tr>
            </thead>

            <tbody>
              {budgetData.budgetList.map((item: any) => (
                <tr key={item.id} className="w-full border-b">
                  <td className="py-3">{item.title}</td>
                  <td className="py-3 ml-6">
                    {item.expenseDate.split("T")[0]}
                  </td>
                  <td className="py-3 font-medium flex justify-end items-center">
                    {parseFloat(item.amount).toFixed(2)} €
                  </td>
                </tr>
              ))}
              {budgetData.budgetList.length === 0 && (
                <tr>
                  <td colSpan={3} className="p-3 text-center text-gray-500">
                    {t("credits.no-expenses")}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="md:hidden">
          {budgetData.budgetList.map((item: any, idx: number) => (
            <>
              <div className="mb-4 flex justify-between">
                <div>
                  <div className="flex items-center mb-1">
                    <div className="text-grey">
                      <span>{item.title}</span>
                    </div>
                  </div>
                  <div className="flex items-center ">
                    <div className="text-Grey">
                      <span className="mr-2">
                        {t("credits.budget-table-date")}:
                      </span>
                      <span>{item.expenseDate.split("T")[0]}</span>
                    </div>
                  </div>
                  <div className="flex items-center ">
                    <div className="text-Grey">
                      <span className="mr-2">
                        {t("credits.budget-table-value")}:
                      </span>
                      <span> {parseFloat(item.amount).toFixed(2)} €</span>
                    </div>
                  </div>
                </div>
              </div>
              {idx + 1 < budgetData?.budgetList.length && (
                <hr className="border-1 border-Grey-light-2 mb-4" />
              )}
            </>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BudgetDisplay;
